import React from 'react';

const STATUS_CONFIG = {
  online:   { color: '#22c55e', label: { nl: 'Online',    en: 'Online'    } },
  inactive: { color: '#f59e0b', label: { nl: 'Inactief',  en: 'Inactive'  } },
  offline:  { color: '#6b7280', label: { nl: 'Offline',   en: 'Offline'   } },
  busy:     { color: '#ef4444', label: { nl: 'Bezig',     en: 'Busy'      } },
  resting:  { color: '#14b8a6', label: { nl: 'Rustend',   en: 'Resting'   } },
};

/**
 * A small coloured circle indicating a user's presence status.
 * @param {string} status  - 'online' | 'inactive' | 'offline' | 'busy' | 'resting'
 * @param {number} size    - diameter in px (default 10)
 * @param {boolean} showLabel - render the text label next to the dot
 * @param {string} lang    - 'nl' | 'en'
 */
function StatusDot({ status = 'offline', size = 10, showLabel = false, lang = 'en' }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.offline;
  const nl = lang === 'nl';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <span
        style={{
          display: 'inline-block',
          width: size,
          height: size,
          borderRadius: '50%',
          background: cfg.color,
          flexShrink: 0,
          boxShadow: status === 'online' ? `0 0 0 2px ${cfg.color}44` : 'none',
        }}
      />
      {showLabel && (
        <span style={{ fontSize: size - 1, color: cfg.color, fontWeight: 500 }}>
          {nl ? cfg.label.nl : cfg.label.en}
        </span>
      )}
    </span>
  );
}

export default StatusDot;
